// extracted by mini-css-extract-plugin
export default {"element":"landing_element__hUvXE","map":"landing_map__PiJgN","links":"landing_links__gwYcK","mi":"landing_mi__BEvPX","ny":"landing_ny__eDIZG"};